__turbopack_context__.v({
  "chevron": "ComboboxField-module__wrh2Sa__chevron",
  "chevronButton": "ComboboxField-module__wrh2Sa__chevronButton",
  "chevronOpen": "ComboboxField-module__wrh2Sa__chevronOpen",
  "control": "ComboboxField-module__wrh2Sa__control",
  "controlError": "ComboboxField-module__wrh2Sa__controlError",
  "controlOpen": "ComboboxField-module__wrh2Sa__controlOpen",
  "disabled": "ComboboxField-module__wrh2Sa__disabled",
  "dropdown": "ComboboxField-module__wrh2Sa__dropdown",
  "dropdown-enter": "ComboboxField-module__wrh2Sa__dropdown-enter",
  "empty": "ComboboxField-module__wrh2Sa__empty",
  "field": "ComboboxField-module__wrh2Sa__field",
  "label": "ComboboxField-module__wrh2Sa__label",
  "option": "ComboboxField-module__wrh2Sa__option",
  "optionCheck": "ComboboxField-module__wrh2Sa__optionCheck",
  "optionHighlighted": "ComboboxField-module__wrh2Sa__optionHighlighted",
  "optionLabel": "ComboboxField-module__wrh2Sa__optionLabel",
  "optionSelected": "ComboboxField-module__wrh2Sa__optionSelected",
  "required": "ComboboxField-module__wrh2Sa__required",
  "trigger": "ComboboxField-module__wrh2Sa__trigger",
  "triggerLabel": "ComboboxField-module__wrh2Sa__triggerLabel",
  "triggerPlaceholder": "ComboboxField-module__wrh2Sa__triggerPlaceholder",
  "wrapper": "ComboboxField-module__wrh2Sa__wrapper",
});
